// extracted by mini-css-extract-plugin
export var playToggle = "SponsorBanner-module--playToggle--OVMa3";
export var sponsorBanner = "SponsorBanner-module--sponsorBanner--xuROi";
export var sponsorSlide = "SponsorBanner-module--sponsorSlide--X2Bbl";
export var sponsorSlides = "SponsorBanner-module--sponsorSlides--45LRI";
export var sponsors = "SponsorBanner-module--sponsors--gxzgZ";